import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { deleteTasById, getTacheByCodeclient, getTasksByCode, getTasksById, getTasksByUsers, updateTache } from "../../Services/Pointeuse/TasksApi";
import { getUsersByCode } from "../../Services/Pointeuse/UsersApi";
import { groupByProject } from "../../Utils/GroupeUtils";
import { reduceObject } from "../../Utils/ObjectOperation";
import { filterTasksByWord } from "../../Utils/SortObject";
import PieChartJsTaskStatus from "../Charts/CustumChartJs/PieChartJsTaskStatus";
import PieChartJsTaskType from "../Charts/CustumChartJs/PieChartJsTaskType";
import CustomSyncLoader from "../Others/CustomSyncLoader";
import ErrorCustum from "../Others/ErrorCustum";
import Pagination from "../Others/Pagination";
import ButtonHeaderComponent from "../Styles/ButtonHeaderComponent";
import ImageComponent from "../Styles/ImageComponent";
import AddTask from "./AddTask";
import swal from "sweetalert";
import ExportCsv from "../Exports/ExportCsv";
import ExportPdf from "../Exports/ExportPdf";
import CopieContent from "../Exports/CopieContent";
import { t } from "i18next";
import { toast } from "react-toastify";
import { IoRefresh } from "react-icons/io5";

function ListTasks({ clientcode }) {
  const [currentData, setcurrentData] = useState([]);
  const [allInitialData, setallInitialData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setdata] = useState([]);
  const [users, setusers] = useState([]);
  const [projetsTask, setprojetsTask] = useState([]);
  const [size, setsize] = useState(14);
  const [isOpened, setIsOpened] = useState(false);
  const [tasks, settasks] = useState(null);
  const history = useHistory();
  const roleuser = localStorage.getItem('role_code')
  const [changeetat, setchangeetat] = useState()
  const [date_debut, setdate_debut] = useState()
  const [date_fin, setdate_fin] = useState()
  const [prioritevalue, setprioritevalue] = useState()
  const [etatvalue, setetatvalue] = useState()

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setLoading(true);
    if (roleuser === "admin") {
      if (clientcode) {
        getTacheByCodeclient(clientcode).then((res) => {

          setdata(res.data);
          setallInitialData(res.data);
          setprojetsTask(groupByProject(res.data));

          settasks(reduceObject(res.data));


        })
          .catch((error) => setError(error))
          .finally(() => setLoading(false));
      } else {
        getTasksByCode().then((res) => {

          setdata(res.data);
          setallInitialData(res.data);
          setprojetsTask(groupByProject(res.data));

          settasks(reduceObject(res.data));


        })
          .catch((error) => setError(error))
          .finally(() => setLoading(false));
      }

    } else {
      const iduser = localStorage.getItem('id')
      if (clientcode) {

        getTacheByCodeclient(clientcode).then((res) => {
          const filtred = res.data.filter(item => item.user_code_id = iduser || item.assignedto === iduser)
          setdata(filtred);
          setallInitialData(filtred);
          setprojetsTask(groupByProject(filtred));

          settasks(reduceObject(filtred));


        })
          .catch((error) => setError(error))
          .finally(() => setLoading(false));
      }
      else {

        getTasksByUsers(iduser).then((res) => {

          setdata(res.data);
          setallInitialData(res.data);
          setprojetsTask(groupByProject(res.data));

          settasks(reduceObject(res.data));


        })
          .catch((error) => setError(error))
          .finally(() => setLoading(false));
      }

    }

  };

  useEffect(() => {
    getUsersByCode().then((res) => {
      setusers(res.data);
    });
  }, []);

  /**
   * The function takes in a page of items and sets the currentData state to that page of items
   * @param pageOfItems - an array of items on the current page.
   */
  const onChangePage = (pageOfItems) => {
    // update state with new page of items
    setcurrentData(pageOfItems);
  };
 
  /**
   * It filters the data by the search term.
   * @param e - The event object that contains the target element.
   */
  const handleSearch = (e) => {

    const filtered = currentData.filter(
      (el) =>
        el?.ownernom?.toLowerCase().includes(e.target.value.toLowerCase()) ||
        el.ownerprenom?.toLowerCase().includes(e.target.value.toLowerCase())

    );
    if (filtered.length === 0) {
      setdata(currentData);
    } else {
      setdata(filtered);

    }
  };
  /**
   * The function sets the size of the data to be retrieved from the API.
   * @param e - The event object that contains the data we want to use.
   */
  const handleChangeSize = (e) => {
    setsize(e.target.value);
    getData();
  };

 
  const handleDelete = (id) => {
    swal({
      title: t("Ëtes-vous sûr ?"),
      text: t("Une fois supprimé, vous ne pourrez pas récupérer cet enregistrement!"),
      icon: "warning",
      // buttons: true,
      buttons: {
        cancel: t("Cancel"), // Traduisez le bouton "Cancel"
        confirm: {
          text: t("OK"), // Traduisez le bouton "OK"
          value: true,
        },
      },
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteTasById(id).then(() => {
          swal(t("Opération effectuée avec succès!"), {
            icon: "success",
          });
          getData();
        });
      }
    });
  };
  const navtotask = (el) => {
    if (roleuser !== 'admin') {
      const codeuser = localStorage.getItem('id')
      if (codeuser !== el.user_code_id && codeuser !== el.assignedto) {
        toast.warning('vous ne pouvez pas accéder a cette tache')
      } else {
        history.push("/user/viewtask/" + el.id);

      }
    } else {
      history.push("/admin/viewtask/" + el.id);

    }
  }

  const handelchange = (index, name, value) => {
    const datalist = [...currentData]
    datalist[index][name] = value
    if (name === 'assignedto') {
      datalist[index].userassignenom = users.find(item => item.id === value)?.nom
      datalist[index].userassigneprenom = users.find(item => item.id === value)?.prenom

    }
    setcurrentData(datalist)



  }
  const update_data = (index) => {
    const tache_element = currentData[index]
    delete tache_element.ownerimg
    delete tache_element.ownernom
    delete tache_element.ownerprenom
    delete tache_element.owneremail
    delete tache_element.userassignenom
    delete tache_element.userassigneprenom
    delete tache_element.projet_date_debut
    delete tache_element.projet_date_fin
    delete tache_element.client_nom
    delete tache_element.client_prenom
    updateTache(tache_element).then((res) => {
      if (res.status === 200) {
        toast.success(t("tache modifiée "));
        setchangeetat()


      }
    });
  }

  const handlfilter = (datedebut, datefin, priorite, status) => {
   const p = priorite ?priorite : '' 
   const s = status ?status : '' 
   const startDate = new Date(datedebut); 
   const endDate = new Date(datefin); 

  

   let filtred = allInitialData ; 
      if(p !==''){
        filtred =filtred.filter((el) => el.priority == p)  ; 
      }
      if(s !== ""){
        filtred =filtred.filter((el) => el.etat == s)  ; 

      }
      if(datedebut  ){
        filtred =filtred.filter((el) => startDate <=  new Date(el.created_at.split(" ")[0]))  ; 

      }
      if(datefin){
        filtred =filtred.filter((el) =>   new Date(el.created_at.split(" ")[0]) <= endDate)  ; 

      }
      setdata(filtred)
  };
  const reintialiser =()=>{
    setdata(allInitialData)
    setdate_debut("")
    setdate_fin("")
    setprioritevalue("")
    setetatvalue('')
  }
  
  return (
    <>
      <div className="page-header d-xl-flex d-block">
        <div className="page-leftheader">
          <h4 className="page-title">{t("Tâches")}</h4>
        </div>
        <div className="page-rightheader ml-md-auto">
          <div className="align-items-end flex-wrap my-auto right-content breadcrumb-right">
            <div className="btn-list">
              <Link to={localStorage.getItem('role_code') === 'admin' ? '/admin/creetask' : '/user/creetask'} className="btn btn-primary mr-3" data-toggle="modal" data-target="#newtaskmodal">
                {t("Ajouter tâche")}
              </Link>
              <ButtonHeaderComponent />
            </div>
          </div>
        </div>
      </div>

      {/* <div className="row">
        <div className="col-xl-3 col-lg-6 col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-7">
                  <div className="mt-0 text-left">
                    <span className="font-weight-semibold">Total Employees</span>
                    <h3 className="mb-0 mt-1 text-success">5,678</h3>
                  </div>
                </div>
                <div className="col-5">
                  <div className="icon1 bg-success-transparent my-auto  float-right">
                    <i className="las la-users" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-lg-6 col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-7">
                  <div className="mt-0 text-left">
                    <span className="font-weight-semibold">Total Homme Employees</span>
                    <h3 className="mb-0 mt-1 text-primary">3,876</h3>
                  </div>
                </div>
                <div className="col-5">
                  <div className="icon1 bg-primary-transparent my-auto  float-right">
                    <i className="las la-male" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-lg-6 col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-7">
                  <div className="mt-0 text-left">
                    <span className="font-weight-semibold">Total Female Employees</span>
                    <h3 className="mb-0 mt-1 text-secondary">1,396</h3>
                  </div>
                </div>
                <div className="col-5">
                  <div className="icon1 bg-secondary-transparent my-auto  float-right">
                    <i className="las la-female" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-lg-6 col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-7">
                  <div className="mt-0 text-left">
                    <span className="font-weight-semibold">Total New Employees</span>
                    <h3 className="mb-0 mt-1 text-danger">398</h3>
                  </div>
                </div>
                <div className="col-5">
                  <div className="icon1 bg-danger-transparent my-auto  float-right">
                    <i className="las la-user-friends" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div className="row">
        <div className="col-xl-12 col-md-12 col-lg-12">
          <div className="card">
            <div className="">
              {tasks && (
                <div className="row justify-content-center">
                <div className="col-md-6 col-lg-1 text-center py-5"onClick={(e) => {handlfilter(date_debut,date_fin,prioritevalue,"afaire") ; setetatvalue("afaire")}}
                >
                    <span className="badge badge-primary" style={{ padding: '20px' }}>{tasks?.afaire ||0 }</span>
                    <h5 className="mb-0 mt-3">{t("a faire")}</h5>
                  </div>
                  <div className="col-md-6 col-lg-1 text-center py-5" onClick={(e) => {handlfilter(date_debut,date_fin,prioritevalue,"encours") ; setetatvalue("encours")}}>
                    <span className="badge badge-warning" style={{ padding: '20px' }}>{tasks?.encours||0}</span>
                    <h5 className="mb-0 mt-3">{t("en cours")}</h5>
                  </div>
                  <div className="col-md-6 col-lg-1 text-center py-5" onClick={(e) => {handlfilter(date_debut,date_fin,prioritevalue,"dev") ; setetatvalue("dev")}}>
                    <span className="badge badge-info" style={{ padding: '20px' }}>{tasks?.dev||0}</span>
                    <h5 className="mb-0 mt-3">{t("dev")}</h5>
                  </div>
                  <div className="col-md-6 col-lg-1 text-center py-5" onClick={(e) => {handlfilter(date_debut,date_fin,prioritevalue,"validee") ; setetatvalue("validee")}}>
                    <span className="badge badge-success" style={{ padding: '20px' }}>{tasks?.validee||0}</span>
                    <h5 className="mb-0 mt-3">{t("validé")}</h5>
                  </div>
                  <div className="col-md-6 col-lg-1 text-center py-5" onClick={(e) => {handlfilter(date_debut,date_fin,prioritevalue,"tester") ; setetatvalue("tester")}}>
                    <span className="badge badge-danger" style={{ padding: '20px' }}>{tasks?.tester||0}</span>
                    <h5 className="mb-0 mt-3">{t("à tester")}</h5>
                  </div>
                  <div className="col-md-6 col-lg-1 text-center py-5" onClick={(e) => {handlfilter(date_debut,date_fin,prioritevalue,"terminee") ; setetatvalue("terminee")}}>
                    <span className="badge badge-secondary" style={{ padding: '20px' }}>{tasks?.terminee||0}</span>
                    <h5 className="mb-0 mt-3">{t("terminé")}</h5>
                  </div>
                  <div className="col-md-6 col-lg-1 text-center py-5" onClick={(e) => {handlfilter(date_debut,date_fin,prioritevalue,"revoir") ; setetatvalue("revoir")}}>
                    <span className="badge badge-default" style={{ padding: '20px' }}>{tasks?.revoir||0}</span>
                    <h5 className="mb-0 mt-3">{t("à revoir")}</h5>
                  </div>
                </div>

              )}


            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-xl-12 col-md-12 col-lg-12">
          <div className="card">
            <div className="card-header  border-0">
              <h4 className="card-title">{t("List tâches")}</h4>
            </div>

            <div className="card-body">

              {/* <div className="d-flex mb-6 mt-5">
                <div className="mr-3">
                  <label className="form-label">{t("Note")}:</label>
                </div>
                <div>
                  <span className="badge badge-primary-light mr-2">
                    <i className="feather feather-check-circle text-primary" /> {t("à faire")}
                  </span>
                  <span className="badge badge-warning-light mr-2">
                    <i className="feather feather-x-circle text-warning" /> {t("en cours")}
                  </span>
                  <span className="badge badge-default-light mr-2">
                    <i className="fa fa-star text-default" /> {t("à revoir")}
                  </span>
                  <span className="badge badge-success-light mr-2">
                    <i className="fa fa-adjust text-success" /> {t("validé")}
                  </span>
                  <span className="badge badge-secondary-light mr-2">
                    <i className="fa fa-star text-secondary" /> {t("terminé")}
                  </span>
                  <span className="badge badge-danger-light mr-2">
                    <i className="fa fa-adjust text-danger" /> {t("à tester")}
                  </span>
                </div>
              </div>*/}
              {/*<div className="row">
                <div className="col-xl-5 col-md-12">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">{t("Début")}:</label>
                        <div className="input-group">
                          <div className="input-group-prepend">
                            <div className="input-group-text">
                              <i className="feather feather-calendar" />
                            </div>
                          </div>
                          <input
                            className="form-control fc-datepicker"
                            placeholder="DD-MM-YYYY"
                            type="date"
                            onChange={(e) => handleStart(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">{t("Fin")}:</label>
                        <div className="input-group">
                          <div className="input-group-prepend">
                            <div className="input-group-text">
                              <i className="feather feather-calendar" />
                            </div>
                          </div>
                          <input
                            className="form-control fc-datepicker"
                            placeholder="DD-MM-YYYY"
                            type="date"
                            onChange={(e) => handleEnd(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-5 col-md-12">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">{t("Priorité")}:</label>
                        <select
                          name="attendance"
                          className="form-control custom-select select2"
                          data-placeholder={t("Choisir priorité")}
                          onChange={(e) => handlePriority(e.target.value)}
                        >
                          <option label={t("Choisir priorité")} />
                          <option value={0}>0-Aucune priorité</option>
                          <option value={1}>1-Priorité la plus élevée</option>
                          <option value={2}>2-Priorité élevée</option>
                          <option value={3}>3-Priorité moyenne</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">{t("Choisir Statut")}:</label>
                        <select
                          name="attendance"
                          className="form-control custom-select select2"
                          data-placeholder={t("Choisir Statut")}
                          onChange={(e) => handleStatus(e.target.value)}
                        >
                          <option label={t("Choisir Statut")} />
                          <option value="afaire">{t("à faire")}</option>
                          <option value="encours">{t("en cours")}</option>
                          <option value="revoir">{t("à revoir")}</option>
                          <option value="validee">{t("validé")}</option>
                          <option value="terminee">{t("terminé")}</option>
                          <option value="tester">{t("à tester")}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 col-md-12">
                  <div className="form-group mt-5">
                    <Link to="#" className="btn btn-primary btn-block" onClick={getData}>
                      {t("Réinitialiser")}
                    </Link>
                  </div>
                </div>
              </div>*/}

              {loading && <CustomSyncLoader></CustomSyncLoader>}
              {!loading && error && <ErrorCustum></ErrorCustum>}
              {!loading && !error && data && (
                <div className="table-responsive">
                  <div id="hr-table_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer">
                    {clientcode ? (
                      <div className="row">
                      <div className="col-sm-12 col-md-12">
                        <div className="dataTables_length" id="hr-table_length">
                          <label>
                            {t("Afficher")}{" "}
                            <select value={size} className="form-control" id="exampleFormControlSelect1" onChange={handleChangeSize}>
                              <option value={8}>8</option>
                              <option value={20}>20</option>
                              <option value={40}>40</option>
                              <option value={60}>60</option>
                              <option value={100}>100</option>
                            </select>{" "}

                          </label>
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-5 mb-2">
                        <div className="input-group">
                          <div className="input-group-prepend">
                            <div className="input-group-text " >
                              <i className="feather feather-calendar" /> {t('Date Debut')}
                            </div>
                          </div>
                          <input
                            onChange={(e) => {
                              setdate_debut(e.target.value);
                            }}
                            value={date_debut}
                            className="form-control fc-datepicker"
                            placeholder="DD-MM-YYYY"
                            type="date"
                          />
                        </div>

                      </div>
                      <div className="col-sm-12 col-md-5 mb-2">
                        <div className="input-group">
                          <div className="input-group-prepend">
                            <div className="input-group-text " >
                              <i className="feather feather-calendar" /> {t('Date Fin')}
                            </div>
                          </div>
                          <input
                            onChange={(e) => {
                              setdate_fin(e.target.value);
                            }}
                            value={date_fin}
                            className="form-control fc-datepicker"
                            placeholder="DD-MM-YYYY"
                            type="date"
                          />
                        </div>

                      </div>

                      <div className="col-sm-12 col-md-2">
                        <button  className="btn btn-primary btn-block" onClick={() => handlfilter(date_debut, date_fin,prioritevalue,etatvalue)}>
                          {t("chercher")}
                        </button>
                      </div>
                      <div className="col-sm-12 col-md-2">
                        <div className="form-group">

                          <select
                            name="attendance"
                            className="form-control custom-select select2"
                            data-placeholder={t("Choisir priorité")}
                            onChange={(e) => handlfilter(date_debut,date_fin,e.target.value,undefined)}
                          >
                            <option value="" label={t("Choisir priorité")} />
                            <option value={0}>0-Aucune priorité</option>
                            <option value={1}>1-Priorité la plus élevée</option>
                            <option value={2}>2-Priorité élevée</option>
                            <option value={3}>3-Priorité moyenne</option>
                          </select>
                        </div>
                      </div>
                    

                      <div className="col-sm-12 col-md-4">
                        <div id="hr-table_filter" className="dataTables_filter">
                          <label className="mr-2">
                            <input
                              type="search"
                              className="form-control"
                              placeholder={t("Recherche...")}
                              aria-controls="hr-table"
                              onChange={handleSearch}
                            />
                          </label>

                          <ExportCsv data={data} name={"List_tâches"} />
                          <ExportPdf data={data} name={"List_tâches"} columns={["object", "description", "etat", "priority", "date_fin"]} />
                          <CopieContent />
                          {/** <div className="col-sm-12 col-md-1">
                      <Link to="#" className="btn btn-primary btn-block" onClick={getData}>
                        {t("Réinitialiser")}
                      </Link>
                    </div> */}
                        </div>
                      </div>

                      <div className="col-sm-12 col-md-2">
                      <div className="btn btn-primary " onClick={reintialiser}><IoRefresh /></div>

                      </div>
                    </div>
                    ) :
                      <div className="row">
                        <div className="col-sm-12 col-md-1">
                          <div className="dataTables_length" id="hr-table_length">
                            <label>
                              {t("Afficher")}{" "}
                              <select value={size} className="form-control" id="exampleFormControlSelect1" onChange={handleChangeSize}>
                                <option value={8}>8</option>
                                <option value={20}>20</option>
                                <option value={40}>40</option>
                                <option value={60}>60</option>
                                <option value={100}>100</option>
                              </select>{" "}

                            </label>
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-2">
                          <div className="input-group">
                            <div className="input-group-prepend">
                              <div className="input-group-text " >
                                <i className="feather feather-calendar" /> {t('Date Debut')}
                              </div>
                            </div>
                            <input
                              onChange={(e) => {
                                setdate_debut(e.target.value);
                              }}
                              value={date_debut}
                              className="form-control fc-datepicker"
                              placeholder="DD-MM-YYYY"
                              type="date"
                            />
                          </div>

                        </div>
                        <div className="col-sm-12 col-md-2">
                          <div className="input-group">
                            <div className="input-group-prepend">
                              <div className="input-group-text " >
                                <i className="feather feather-calendar" /> {t('Date Fin')}
                              </div>
                            </div>
                            <input
                              onChange={(e) => {
                                setdate_fin(e.target.value);
                              }}
                              value={date_fin}
                              className="form-control fc-datepicker"
                              placeholder="DD-MM-YYYY"
                              type="date"
                            />
                          </div>

                        </div>

                        <div className="col-sm-12 col-md-1">
                          <button className="btn btn-primary btn-block" onClick={() => handlfilter(date_debut, date_fin,prioritevalue,etatvalue)}>
                            {t("chercher")}
                          </button>
                        </div>
                        <div className="col-sm-12 col-md-2">
                          <div className="form-group">

                            <select
                              name="attendance"
                              className="form-control custom-select select2"
                              data-placeholder={t("Choisir priorité")}
                              onChange={(e) => {
                                handlfilter(date_debut, date_fin, e.target.value, etatvalue);
                                setprioritevalue(e.target.value);
                              }}                        >
                              <option value="" label={t("Choisir priorité")} />
                              <option value={0}>0-Aucune priorité</option>
                              <option value={1}>1-Priorité la plus élevée</option>
                              <option value={2}>2-Priorité élevée</option>
                              <option value={3}>3-Priorité moyenne</option>
                            </select>
                          </div>
                        </div>
                        
                     

                        <div className="col-sm-12 col-md-3">
                          <div id="hr-table_filter" className="dataTables_filter">
                            <label className="mr-2">
                              <input
                                type="search"
                                className="form-control"
                                placeholder={t("Recherche...")}
                                aria-controls="hr-table"
                                onChange={handleSearch}
                              />
                            </label>

                            <ExportCsv data={data} name={"List_tâches"} />
                            <ExportPdf data={data} name={"List_tâches"} columns={["object", "description", "etat", "priority", "date_fin"]} />
                            <CopieContent />
                            {/** <div className="col-sm-12 col-md-1">
                        <Link to="#" className="btn btn-primary btn-block" onClick={getData}>
                          {t("Réinitialiser")}
                        </Link>
                      </div> */}
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-1">
                      <div className="btn btn-primary " onClick={reintialiser}><IoRefresh /></div>

                      </div>
                      </div>}
                    <div className="row">
                      <div className="col-sm-12">
                        <table className="table  table-vcenter text-nowrap table-bordered border-bottom" id="task-list">
                          <thead>
                            <tr>
                              <th className="border-bottom-0">{t("Tâche")}</th>
                              <th className="border-bottom-0">{t("Projet")}</th>
                              <th className="border-bottom-0">{t("client")}</th>
                              <th className="border-bottom-0">{t("Assigné")}</th>
                              <th className="border-bottom-0">{t("Re Assigné")}</th>
                              <th className="border-bottom-0">{t("Priorité")}</th>
                              <th className="border-bottom-0">{t("Type")}</th>
                              <th className="border-bottom-0">{t("Date début")}</th>
                              <th className="border-bottom-0">{t("Date fin")}</th>
                              <th className="border-bottom-0">{t("Statut")}</th>
                              <th className="border-bottom-0">{t("Actions")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentData.map((el, idx) => (
                              <tr key={idx}>
                                <td onClick={() => navtotask(el)}>
                                  <div className="d-flex sidebarmodal-collpase">
                                    <span className="dot-label1 mr-2 mt-1" style={{ backgroundColor: `${el.color}` }} />
                                    <span data-toggle="tooltip" data-placement="top" title={el.description}>
                                      {el.object}
                                    </span>
                                  </div>
                                </td>
                                <td>
                                  <Link to={"/admin/projects/" + el.projet_id} className="d-flex sidebarmodal-collpase">
                                    {el.projet}
                                  </Link>
                                </td>
                                <td>
                                  {el.client_nom !== null ? el.client_nom : el.client_fc_nom + ' ' + el.client_fc_prenom} {' '}{el.client_prenom}

                                </td>
                                <td>
                                  <a href="task-profile.html" className="d-flex">
                                    <ImageComponent atr={"avatar avatar-md brround mr-3"} picture={el.img}></ImageComponent>
                                    <div className="mr-3 mt-0 mt-sm-2 d-block">
                                      <h6 className="mb-1 fs-14">
                                        <Link to={"/admin/users/" + el.user_code_id}>
                                          {el.ownernom} {el.ownerprenom}
                                        </Link>
                                      </h6>
                                    </div>
                                  </a>
                                </td>
                                {(changeetat?.etat && changeetat.index === idx && el.etat === 'dev') ? (
                                  <td>

                                    <select
                                      onChange={(e) => handelchange(idx, 'assignedto', e.target.value)}
                                      className="selectpicker form-control"
                                      value={el.assignedto}>
                                      <option value="0">{t("Choisir un collaborateur")}</option>
                                      {users &&
                                        users.map((el, idx) => (
                                          <option key={idx} value={el.id}>
                                            {el.nom} {el.prenom}
                                          </option>
                                        ))}
                                    </select>
                                  </td>
                                ) :
                                  <td>
                                    <a href="task-profile.html" className="d-flex">
                                      <div className="mr-3 mt-0 mt-sm-2 d-block">
                                        <h6 className="mb-1 fs-14">
                                          <Link to={"/admin/users/" + el.assignedto}>
                                            {el.userassignenom} {el.userassigneprenom}
                                          </Link>
                                        </h6>
                                      </div>
                                    </a>
                                  </td>
                                }

                                <td>
                                  {el.priority == 0 && <span className="badge badge-success-light">{el.priority}</span>}
                                  {el.priority == 1 && <span className="badge badge-warning-light">{el.priority}</span>}
                                  {el.priority == 2 && <span className="badge badge-orange-light">{el.priority}</span>}
                                  {el.priority == 3 && <span className="badge badge-danger-light">{el.priority}</span>}
                                </td>
                                <td>
                                  {el.type == "task" ? (<span className="badge badge-primary-light">{t("tâche")}</span>) :
                                    el.type == "bug" ? <span className="badge badge-danger-light">{el.type}</span> :
                                      <span className="badge badge-danger-light">{el.type}</span>
                                  }
                                </td>
                                <td>{el.date_debut && el.date_debut.split(" ")[0]}</td>
                                <td>{el.date_fin && el.date_fin.split(" ")[0]}</td>
                                {(changeetat?.etat && changeetat?.index === idx) ? (
                                  <td>
                                    <div className="form-group">
                                      <select
                                        name="attendance"
                                        className="form-control custom-select select2"
                                        data-placeholder={t("Choisir Statut")}
                                        onChange={(e) => handelchange(idx, 'etat', e.target.value)}
                                        value={el.etat}

                                      >
                                        <option label={t("Choisir Statut")} />
                                        <option value="afaire">{t("à faire")}</option>
                                        <option value="encours">{t("en cours")}</option>
                                        <option value="dev">{t("développement")}</option>
                                        <option value="tester">{t("à tester")}</option>
                                        <option value="terminee">{t("terminé")}</option>
                                        <option value="revoir">{t("à revoir")}</option>

                                      </select>
                                    </div>
                                  </td>
                                ) :
                                  <td onDoubleClick={() => setchangeetat({ etat: true, index: idx })}>
                                    <>
                                      {el.etat === "afaire" && (
                                        <div className="d-flex">
                                          <span className="badge badge-primary">{el.etat}</span>
                                          <div className="mt-1 ml-1">
                                            <span
                                              className="feather feather-info text-primary"
                                              data-toggle="tooltip"
                                              data-placement="top"
                                              title="Terminé"
                                            />
                                          </div>
                                        </div>
                                      )}
                                      {el.etat === "encours" && (
                                        <div className="d-flex">
                                          <span className="badge badge-warning">{el.etat}</span>
                                          <div className="mt-1 ml-1">
                                            <span
                                              className="feather feather-info text-danger"
                                              data-toggle="tooltip"
                                              data-placement="top"
                                              title="Terminé"
                                            />
                                          </div>
                                        </div>
                                      )}
                                      {el.etat === "dev" && (
                                        <div className="d-flex">
                                          <span className="badge badge-info">{el.etat}</span>
                                          <div className="mt-1 ml-1">
                                            <span
                                              className="feather feather-info text-danger"
                                              data-toggle="tooltip"
                                              data-placement="top"
                                              title="Terminé"
                                            />
                                          </div>
                                        </div>
                                      )}
                                      {el.etat === "revoir" && (
                                        <div className="d-flex">
                                          <span className="badge badge-default">{el.etat}</span>
                                          <div className="mt-1 ml-1">
                                            <span
                                              className="feather feather-info text-default"
                                              data-toggle="tooltip"
                                              data-placement="top"
                                              title="Terminé"
                                            />
                                          </div>
                                        </div>
                                      )}
                                      {el.etat === "validee" && (
                                        <div className="d-flex">
                                          <span className="badge badge-success">{el.etat}</span>
                                          <div className="mt-1 ml-1">
                                            <span
                                              className="feather feather-info text-success"
                                              data-toggle="tooltip"
                                              data-placement="top"
                                              title="Terminé"
                                            />
                                          </div>
                                        </div>
                                      )}
                                      {el.etat === "terminee" && (
                                        <div className="d-flex">
                                          <span className="badge badge-secondary">{el.etat}</span>
                                          <div className="mt-1 ml-1">
                                            <span
                                              className="feather feather-info text-secondary"
                                              data-toggle="tooltip"
                                              data-placement="top"
                                              title="Terminé"
                                            />
                                          </div>
                                        </div>
                                      )}
                                      {el.etat === "tester" && (
                                        <div className="d-flex">
                                          <span className="badge badge-danger">{el.etat}</span>
                                          <div className="mt-1 ml-1">
                                            <span
                                              className="feather feather-info text-danger"
                                              data-toggle="tooltip"
                                              data-placement="top"
                                              title="Terminé"
                                            />
                                          </div>
                                        </div>
                                      )}
                                    </>
                                  </td>
                                }


                                <td>
                                  <div className="d-flex">
                                    {(changeetat?.etat && changeetat.index === idx) && (
                                      <p onClick={() => update_data(idx)} className="action-btns1">
                                        <i
                                          className="feather feather-save text-success"
                                          data-toggle="tooltip"
                                          data-placement="top"
                                          title="Save task"
                                        />
                                      </p>

                                    )}
                                    <p onClick={() => navtotask(el)} className="action-btns1">
                                      <i
                                        className="feather feather-edit-2  text-success"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="Edit task"
                                      />
                                    </p>

                                    <Link
                                      to="#"
                                      className="action-btns1"
                                      data-toggle="tooltip"
                                      data-placement="top"
                                      title="Delete Task"
                                      onClick={() => handleDelete(el.id)}
                                    >
                                      <i className="feather feather-trash-2 text-danger" />
                                    </Link>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 col-md-5">
                        <div className="dataTables_info" id="hr-table_info" role="status" aria-live="polite">
                          {t("Affichage")} {t("de")} 1 {t("à")} {size} {t("sur")} {data.length} {t("entrées")}
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-7">
                        <Pagination items={data} onChangePage={onChangePage} pageSize={size} />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

      </div>

      {/* modal */}
      <AddTask getData={getData} from={false}></AddTask>
      {/* modal */}
      {/* {isOpened && (
        <div className="task-fade sidebar-modal">
          <div className="sidebar-dialog task-modal">
            <div className="sidebar-content">
              <div className="sidebar-header">
                <div>
                  <h4>
                    <span className="font-weight-normal text-muted mr-2">Task 01</span> Design Updated{" "}
                  </h4>
                  <label className="mr-2">Priority:</label>
                  <span className="badge badge-danger-light">High</span>
                </div>
                <div className="ml-auto mt-3">
                  <a href="#" className="btn btn-success mr-2">
                    Mark as Complete
                  </a>
                  <a href="#" className="action-btns" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i className="feather feather-more-horizontal" />
                  </a>
                  <ul className="dropdown-menu dropdown-menu-right" role="menu">
                    <li>
                      <a href="#">
                        <i className="feather feather-eye mr-2" />
                        View
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="feather feather-plus-circle mr-2" />
                        Add
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="feather feather-send mr-2" />
                        Send
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="feather feather-edit-2 mr-2" />
                        Edit
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="feather feather-trash-2 mr-2" />
                        Remove
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="feather feather-settings mr-2" />
                        More
                      </a>
                    </li>
                  </ul>
                  <a href="#" className="action-btns dismiss">
                    <i className="feather feather-x" />
                  </a>
                </div>
              </div>
              <div className="row no-gutters">
                <div className="col-md-8 border-right">
                  <div className="card-body">
                    <h5 className="mb-4  font-weight-semibold">Description</h5>
                    <div className="main-profile-bio mb-0">
                      <span className="fs-14 mt-2 text-muted">
                        Mobile App Ui Designing and Prototyping It is a long established fact that a reader will be
                        distracted by the readable content of a page when looking
                      </span>
                      <p>
                        simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's
                        standard dummy when an unknown printer took a galley of type and scrambled it to make a type
                        specimen book. It has survived not only five centuries nchanged.
                      </p>
                      <h5 className="mb-4 mt-5 font-weight-semibold">Attachments</h5>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="p-3 br-7 border text-center">
                            <a href="#" className="text-center">
                              <img
                                src="assets/images/files/attachments/2.png"
                                alt="img"
                                className="avatar bg-transparent avatar-lg mb-2"
                              />
                              <div>
                                <span className="font-weight-semibold fs-12">
                                  doc.pdf<span className="text-muted ml-2">(23.8 KB)</span>
                                </span>
                              </div>
                            </a>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="p-3 br-7 border text-center mt-4 mt-lg-0">
                            <a href="#" className="text-center">
                              <img
                                src="assets/images/files/attachments/4.png"
                                alt="img"
                                className="avatar bg-transparent avatar-lg mb-2"
                              />
                              <div>
                                <span className="font-weight-semibold fs-12">
                                  Project<span className="text-muted ml-2">(578.6MB)</span>
                                </span>
                              </div>
                            </a>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="p-5 br-7 border text-center mt-4 mt-lg-0">
                            <a href="#" className="text-center fs-35 text-success">
                              <i className="fe feather-plus-circle" />
                            </a>
                          </div>
                        </div>
                      </div>
                      <h5 className="mb-4 mt-5 font-weight-semibold">Add Comment</h5>
                      <div className="form-group">
                        <label className="form-label">Title</label>
                        <input className="form-control" placeholder="text" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Description</label>
                        <div className="summernote1" />
                      </div>
                      <a href="#" className="btn btn-primary">
                        Submit
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card-body">
                    <div className="form-group mb-5">
                      <label>Assigned To:</label>
                      <div className="d-flex">
                        <span
                          className="avatar avatar-md brround mr-3"
                          style={{ backgroundImage: "url(assets/images/users/1.jpg)" }}
                        />
                        <div className="mr-3 mt-0 mt-sm-1 d-block">
                          <h6 className="mb-1 fs-14">Faith Harris</h6>
                          <p className="text-muted mb-0 fs-12">Web Designer</p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group mb-5">
                      <label className="mb-1">Département:</label>
                      <p className="form-label">Designing</p>
                    </div>
                    <div className="form-group mb-5">
                      <label className="mb-1">Start Date:</label>
                      <p className="form-label">12-02-2021</p>
                    </div>
                    <div className="form-group mb-5">
                      <label className="mb-1">Deadline Date:</label>
                      <p className="form-label">16-06-2021</p>
                    </div>
                    <div className="form-group mb-5">
                      <label className="mb-1">Work Status:</label>
                      <div>
                        <span className="badge badge-warning">On hold</span>
                      </div>
                    </div>
                    <div className="d-flex align-items-end justify-content-between mt-5">
                      <h6>Project Status</h6>
                      <h6 className="font-weight-bold mb-1">30%</h6>
                    </div>
                    <div className="progress progress-sm">
                      <div className="progress-bar bg-success w-30" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )} */}
    </>
  );
}

export default ListTasks;
/*    <div className="col-xl-3 col-md-12 col-lg-12">
          <div className="card">
            <div className="card-header  border-0">
              <h4 className="card-title">{t("Aperçu Tâches")}</h4>
            </div>
            <div className="card-body">
              <div id="leavesoverview" className="mx-auto pt-2" />
              <div className="row pt-7 pb-5  mx-auto text-center">
                <div className="col-md-12 mx-auto d-block">
                  <div className="row">
                    <div className="col-md-12 mt-3">
                      <div className="d-flex font-weight-semibold">
                        <PieChartJsTaskType />
                      </div>
                    </div>

                    {/* <div className="col-md-12 mt-3">
                      <div className="d-flex font-weight-semibold">
                        <span className="dot-label badge-success mr-2 my-auto" />
                        Vacciné
                      </div>
                    </div>

                    <div className="col-md-12 mt-3">
                      <div className="d-flex font-weight-semibold">
                        <span className="dot-label bg-danger mr-2 my-auto" />
                        Non vacciné
                      </div>
                    </div> 
                    </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header  border-0">
                  <h4 className="card-title">{t("Aperçu Tâches")}</h4>
                </div>
                <div className="card-body">
                  <div id="leavesoverview" className="mx-auto pt-2" />
                  <div className="row pt-7 pb-5  mx-auto text-center">
                    <div className="col-md-12 mx-auto d-block">
                      <div className="row">
                        <div className="col-md-12 mt-3">
                          <div className="d-flex font-weight-semibold">
                            <PieChartJsTaskStatus />
                          </div>
                        </div>
    
                         <div className="col-md-12 mt-3">
                          <div className="d-flex font-weight-semibold">
                            <span className="dot-label badge-success mr-2 my-auto" />
                            Vacciné
                          </div>
                        </div>
    
                        <div className="col-md-12 mt-3">
                          <div className="d-flex font-weight-semibold">
                            <span className="dot-label bg-danger mr-2 my-auto" />
                            Non vacciné
                          </div>
                        </div> *
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>*/